import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  useLocation
} from 'react-router-dom';

// Import page components
import HomePage from './components/HomePage';
import FeaturesPage from './components/FeaturesPage';
import ResidentsPage from './components/ResidentsPage';
import ManagersPage from './components/ManagersPage';
import SupportPage from './components/SupportPage';
import ArticlesPage from './components/ArticlesPage';
import PrivacyPage from './components/PrivacyPage';
import TermsPage from './components/TermsPage';
import Navigation from './components/Navigation';

// Alternative approach - create enhanced components
const HomePageWithRouter = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <HomePage showPage={navigate} />;
};

const FeaturesPageWithRouter = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <FeaturesPage showPage={navigate} />;
};

const ResidentsPageWithRouter = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <ResidentsPage showPage={navigate} />;
};

const ManagersPageWithRouter = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <ManagersPage showPage={navigate} />;
};

const SupportPageWithRouter = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <SupportPage showPage={navigate} />;
};

const ArticlesPageWithRouter = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <ArticlesPage showPage={navigate} />;
};

const PrivacyPageWithRouter = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <PrivacyPage showPage={navigate} />;
};

const TermsPageWithRouter = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <TermsPage showPage={navigate} />;
};

const NotFoundPage = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-[80vh] flex items-center justify-center bg-background-50">
      <div className="text-center px-4">
        <div className="font-heading text-8xl font-extrabold text-primary-600 mb-4">404</div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold text-neutral-900 mb-3">Page not found</h1>
        <p className="text-neutral-500 mb-8 max-w-md mx-auto">The page you're looking for doesn't exist or has been moved.</p>
        <button
          onClick={() => navigate('/')}
          className="inline-flex items-center justify-center px-6 py-3 text-sm font-semibold rounded-small text-white bg-primary-600 hover:bg-primary-700 shadow-custom transition-all"
        >
          Back to Home
        </button>
      </div>
    </div>
  );
};

const TRANSPARENT_NAV_PAGES = ['/', '/managers', '/residents'];

const AppLayout = ({ children }) => {
  const location = useLocation();
  const needsSpacer = !TRANSPARENT_NAV_PAGES.includes(location.pathname);
  return (
    <div className="min-h-screen">
      <Navigation />
      {/* Spacer for fixed nav on pages without transparent hero */}
      {needsSpacer && <div className="h-16" />}
      {children}
    </div>
  );
};

const BilmWebsite = () => {
  return (
    <Router>
      <AppLayout>
        <Routes>
          <Route path="/" element={<HomePageWithRouter />} />
          <Route path="/features" element={<FeaturesPageWithRouter />} />
          <Route path="/residents" element={<ResidentsPageWithRouter />} />
          <Route path="/managers" element={<ManagersPageWithRouter />} />
          <Route path="/support" element={<SupportPageWithRouter />} />
          <Route path="/articles" element={<ArticlesPageWithRouter />} />
          <Route path="/privacy" element={<PrivacyPageWithRouter />} />
          <Route path="/terms" element={<TermsPageWithRouter />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </AppLayout>
    </Router>
  );
};

export default BilmWebsite;
